<div class="modal-header border-bottom-0">
  <div class="d-inline-block">
    <h5 class="modal-title d-block text-primary">{{translationPrefix + '.heading' | translate}}</h5>
  </div>
</div>
<div [formGroup]="countyForm" class="modal-body">
  @for (county of counties; track county.county; let i = $index) {
  <div [ngClass]="{'border-bottom': i === counties.length - 1}" class="border-top border-left border-right px-2 py-3">
    <div class="form-check abc-radio abc-radio-success">
      <input [value]="county.county" class="form-check-input" formControlName="county" id="county-option-{{i}}" type="radio" />
      <label class="form-check-label" for="county-option-{{i}}">{{county.county}}</label>
    </div>
  </div>
  }
</div>
<div class="modal-footer border-top-0 text-center text-md-right">
  <button (click)="emitSelectionMade()" [disabled]="countyForm.invalid" class="btn btn-success text-capitalize px-5">
    {{'common.buttonLabels.done' | translate}}
  </button>
</div>
